import {
  FC,
  useState,
  useEffect,
  createContext,
  useContext,
  useRef,
  Dispatch,
  SetStateAction,
} from 'react'
import {LayoutSplashScreen} from '../../../../_payairo/layout/core'
import {AuthModel, UserModel} from './_models'
import * as authHelper from './AuthHelpers'
import {clearAuthSession} from './authTokenService'
import {WithChildren} from '../../../../_payairo/helpers'
import {AUTH_LOCAL_STORAGE_KEY} from '../../../utils'

type AuthContextProps = {
  auth: AuthModel | undefined
  saveAuth: (auth: AuthModel | undefined) => void
  currentUser: UserModel | undefined
  setCurrentUser: Dispatch<SetStateAction<UserModel | undefined>>
  logout: () => void
  checkPermission: (page: string, permission: string) => boolean
}

const initAuthContextPropsState = {
  auth: authHelper.getAuth(),
  saveAuth: () => {},
  currentUser: undefined,
  setCurrentUser: () => {},
  logout: () => {},
  checkPermission: (page: string, permission: string) => {
    return false
  },
}

const AuthContext = createContext<AuthContextProps>(initAuthContextPropsState)

const useAuth = () => {
  return useContext(AuthContext)
}

const AuthProvider: FC<WithChildren> = ({children}) => {
  const [auth, setAuth] = useState<AuthModel | undefined>(authHelper.getAuth())
  const [currentUser, setCurrentUser] = useState<UserModel | undefined>()
  const saveAuth = (auth: AuthModel | undefined) => {
    setAuth(auth)
    if (auth) {
      authHelper.setAuth(auth)
    } else {
      authHelper.removeAuth()
    }
  }
  const checkPermission = (page: string, permission: string) => {
    const temp = currentUser?.group_obj?.group_permissions?.filter(
      (ele) => ele?.permission?.name == page
    )
    if (temp?.length > 0 && temp[0][permission]) {
      return true
    }
    return false
  }

  const logout = () => {
    clearAuthSession()
    saveAuth(undefined)
    setCurrentUser(undefined)
  }

  return (
    <AuthContext.Provider
      value={{auth, saveAuth, currentUser, setCurrentUser, logout, checkPermission}}
    >
      {children}
    </AuthContext.Provider>
  )
}

const AuthInit: FC<WithChildren> = ({children}) => {
  const {auth, logout, currentUser, setCurrentUser} = useAuth()
  const didRequest = useRef(false)
  const [showSplashScreen, setShowSplashScreen] = useState(true)
  // We should request user by authToken (IN OUR EXAMPLE IT'S API_TOKEN) before rendering the application
  useEffect(() => {
    const requestUser = async (apiToken: string) => {
      try {
        if (!didRequest.current) {
          if (localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)) {
            const mData = JSON.parse(localStorage.getItem(AUTH_LOCAL_STORAGE_KEY) || '')
            // Restore user data with role, userId, profileData
            const userData = mData?.user || mData
            const userRole = userData?.role || mData?.role
            const userType = userData?.user_type || mData?.user_type

            setCurrentUser({
              ...userData,
              role: userRole,
              user_type: userType,
              profileData: userData?.profileData || mData?.profileData,
            })
          }
        }
      } catch (error) {
        // console.error(error)
        // if (!didRequest.current) {
        //   logout()
        // }
      } finally {
        setShowSplashScreen(false)
      }

      return () => (didRequest.current = true)
    }

    if (auth && auth.access_token) {
      requestUser(auth.access_token)
    } else {
      logout()
      setShowSplashScreen(false)
    }
    // eslint-disable-next-line
  }, [])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{children}</>
}

export {AuthProvider, AuthInit, useAuth}
